import Api from "./api";

export async function getDetailsById(id) {
  try {
    const response = await Api.get(`/faq/${id}`);
    return response.data;
  } catch(err) {
    return err;
  }
}